export enum StorageEnum {
  Token = 'token',
  UserData = 'user-data',
  Beneficiary = 'beneficiary',
  AccountDisabledMessage = 'account-disabled-message',
  MasterUserData = 'master-user-data',
  TokenExpiration = 'token-expiration',
}
